var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 19.6V10H.4V6.8h3.2V5.082C3.6 1.828 5.185.4 7.89.4c1.294 0 1.98.096 2.303.14V3.6H8.35C7.201 3.6 6.8 4.206 6.8 5.433V6.8h3.364L9.708 10H6.8v9.6H3.6z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNjAwMzkgMTkuNlYxMEgwLjQwMDM5MVY2LjgwMDAySDMuNjAwMzlWNS4wODE2MkMzLjYwMDM5IDEuODI4MDIgNS4xODUxOSAwLjQwMDAyNCA3Ljg4OTE5IDAuNDAwMDI0QzkuMTg0MzkgMC40MDAwMjQgOS44NjkxOSAwLjQ5NjAyNCAxMC4xOTMyIDAuNTQwMDI0VjMuNjAwMDJIOC4zNDkxOUM3LjIwMTE5IDMuNjAwMDIgNi44MDAzOSA0LjIwNTYyIDYuODAwMzkgNS40MzI4MlY2LjgwMDAySDEwLjE2NDRMOS43MDc1OSAxMEg2LjgwMDM5VjE5LjZIMy42MDAzOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgFacebook as ReactComponent };